import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import styled from 'styled-components';
import { View, Image } from '@components';
import Informacoes from './Informacoes';

const HeaderLayout = styled(Layout.Header)`
  padding-left: 0px;
  padding-right: 15px;
  display: flex;
`;

const LeftView = styled(View)`
  overflow: hidden;
  height: 64px;
  line-height: 64px;
  width: 200px;
`;

const LogoImage = styled(Image)`
  width: 200px;
  object-fit: contain;
  max-height: 30px;
  user-select: none;
`;

const RightView = styled(View)`
  margin: auto;
  float: right;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  display: flex;
  align-items: center;
`;

const BodyView = styled(View)`
  flex: 1;
  user-select: none;
`;

const Header = ({ infoUsuario }) => (
  <HeaderLayout>
    <LeftView>
      <Link to="/">
        <LogoImage alt="TeamMove" src={process.env.PUBLIC_URL + '/images/logo.png'} />
      </Link>
    </LeftView>

    <BodyView />

    <RightView>
      <Informacoes infoUsuario={infoUsuario} />
    </RightView>
  </HeaderLayout>
);

export default Header;
